import React from "react";

interface Props {
  handleOpenMenu: () => void;
}

export const MobileMenuButton = ({ handleOpenMenu }: Props) => {
  return (
    <button className="Header__mobile_menu_button" onClick={handleOpenMenu}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_416_20781)">
          <path
            d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_416_20781">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  );
};
